<!-- MFITTで一度日付変更しているチケットを再度変更しようとした場合 -->
<template>
  <ItemDialog ref="canNotChangePurchasedTicket" image-type="alert">
    <template #content-area>
      <p class="text-center">
        すでに一度日付を変更しているため日付を変更することはできません。<br />
        日付の変更は1回のみ可能です。
      </p>
    </template>
    <template #button-area>
      <ItemButton
        label="閉じる"
        action-type="btn-primary"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";

export default {
  name: "DialogCanNotChangePurchasedTicket",
  setup() {
    const canNotChangePurchasedTicket = ref(null);

    const openDialog = () => {
      canNotChangePurchasedTicket.value.open();
    };

    const closeDialog = () => {
      canNotChangePurchasedTicket.value.close();
    };

    return {
      canNotChangePurchasedTicket,
      openDialog,
      closeDialog,
    };
  },
};
</script>
